export const errorList: any = new Map([
  [504, "Gateway Network Interrupted"],
  [503, "Service Unavailable"],
  [502, "Gateway Network Interrupted"],
  [500, "Internal Server Error"],
  [409, "Service Unavailable"],
  [405, "System Unavailable"],
  [404, "Not Found"],
  [403, "Don't have permission to access"],
  [401, "Unauthorized"],
  [400, "Bad Request"],
  [0, "Bad Network, Please check your internet connection."],
])

export const config = {
  app: "SoS",
  version: "1.0.0",
  logo: "favicon.png",
  logoM: "favicon.png",
  copyright: `${new Date().getFullYear()}`,
}
